import { Outlet, useParams } from 'react-router-dom';

import { SpaceDiscriminator } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { AgreementsCard } from '../../../components/agreements-card/agreements-card.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function SpaceAgreementsRoute() {
  const { spaceId } = useParams<{ buildingId: string; spaceId: string; discriminator: SpaceDiscriminator }>();

  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <AgreementsCard spaceId={spaceId} />
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
